import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

interface OnboardedPercentageResponse {
  message: string;
  entity: {
    expectedTotal: number;
    percentage: string; // e.g. "0.03%"
    onboardedCount: number;
  };
  statusCode: number;
}
interface LoggedInUser {
  firstName: string;
  lastName: string;
  
}

@Component({
  selector: 'app-headers',
  templateUrl: './headers.component.html',
  styleUrls: ['./headers.component.css']
})
export class HeadersComponent implements OnInit, AfterViewInit {
  @ViewChild('chart') chart!: ChartComponent;
  @ViewChild('chartContainer') chartContainer!: ElementRef;

  userName: string = '';

  radialChartOptions: any = {
    series: [0],
    chart: {
      type: 'radialBar',
      height: '100%',
      width: '100%',
      sparkline: { enabled: true }
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 225,
        hollow: {
          margin: 0,
          size: '70%',
          background: '#ffffff',
          dropShadow: { enabled: false }
        },
        track: {
          background: '#e9ede9',
          strokeWidth: '100%',
          margin: 0
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            color: '#4f8c5d',
            fontSize: '12px',
            offsetY: 50,
            fontWeight: 600,
            formatter: () => 'ONBOARDING'
          },
          value: {
            show: true,
            fontSize: '22px',
            fontWeight: 700,
            color: '#4f8c5d',
            offsetY: -10,
            formatter: () => '0.00%'
          }
        }
      }
    },
    fill: {
      colors: ['#d9822b']
    },
    stroke: {
      lineCap: 'round'
    },
    labels: ['Progress']
  };

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.fetchOnboardedPercentage();
    this.setUserNameFromLocalStorage();
  }

  setUserNameFromLocalStorage(): void {
    const userJson = localStorage.getItem('auth-user'); // or the key your app uses
    if (userJson) {
      try {
        const user: LoggedInUser = JSON.parse(userJson);
        this.userName = `${user.firstName} ${user.lastName}`;
      } catch (error) {
        console.error('Failed to parse user from localStorage', error);
        this.userName = 'A.N. Other';
      }
    } else {
      this.userName = 'A.N. Other';
    }
  }

  /**
   * Fetch onboarding percentage and update chart dynamically
   */
  fetchOnboardedPercentage(): void {
    const url = `${environment.baseUrl}/api/v1/reports/animals/onboarded-percentage`;

    console.log('📡 Fetching onboarded percentage from:', url);

    this.http.get<OnboardedPercentageResponse>(url).subscribe({
      next: (res) => {
        console.log('✅ [Onboarded Percentage] Response:', res);

        if (res?.entity?.percentage) {
          const percentageStr = res.entity.percentage.replace('%', '');
          const percentageNum = parseFloat(percentageStr) || 0;

          console.log('📊 Onboarded percentage (numeric):', percentageNum);

          // Update chart series and value label
          if (this.chart?.chart) {
            this.chart.updateOptions({
              series: [percentageNum],
              plotOptions: {
                radialBar: {
                  dataLabels: {
                    value: {
                      formatter: () => `${percentageNum.toFixed(2)}%`
                    }
                  }
                }
              }
            });
          } else {
            this.radialChartOptions.series = [percentageNum];
            this.radialChartOptions.plotOptions.radialBar.dataLabels.value.formatter = () =>
              `${percentageNum.toFixed(2)}%`;
          }
        } else {
          console.warn('⚠️ Unexpected API structure:', res);
        }
      },
      error: (err) => {
        console.error('❌ Error fetching onboarding percentage:', err);
      }
    });
  }

  ngAfterViewInit(): void {
    // Adjust chart to fit its container
    setTimeout(() => {
      const width = this.chartContainer?.nativeElement?.offsetWidth || 160;
      this.chart.updateOptions({
        chart: {
          width: width,
          height: width
        }
      });
    }, 200);
  }
}
